<template>
  <artmisads-select
    :width="width"
    class="country"
    :dropdownMatchSelectWidth="false"
    :value="modelValue"
    :getPopupContainer="getPopupContainer"
    @change="onChange"
  >
    <a-select-option
      v-for="item in countryOptions"
      :key="item.code"
      class="country-select-item"
      :value="item.host"
    >
      <svg class="icon" aria-hidden="true">
        <use :xlink:href="'#icon-' + item.icon"></use>
      </svg>
      {{ item.host }}
    </a-select-option>
  </artmisads-select>
</template>

<script setup>
import { computed } from 'vue'
import { CURRENCY_MAPPER } from '@/contants/common'

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  width: {
    type: [Number, String],
    default: 200,
  },
  getPopupContainer: {
    type: Function,
    default: undefined,
  },
})

const emit = defineEmits(['update:modelValue', 'change'])

const countryOptions = computed(() =>
  Object.keys(CURRENCY_MAPPER).map((code) => {
    const item = CURRENCY_MAPPER[code]
    return {
      code,
      host: item.host,
      currency: item.currency,
      icon: item.icon || `guoqi-${code.toLowerCase()}`,
    }
  }),
)

const onChange = (host) => {
  const selected = countryOptions.value.find((item) => item.host === host)
  if (!selected) return

  emit('update:modelValue', host)
  emit('change', {
    value: host,
    currency: selected.currency,
    key: selected.code.toLowerCase(),
  })
}
</script>

<style lang="less">
@import '@/assets/less/country-select.less';
</style>
